import { ListCandidate } from '../../../../../../entities/applicant_tracking/ListCandidate';

export function checkIfSelectedCandidatesHaveSameStatus(
  selectedCandidates: ListCandidate[],
): boolean {
  if (selectedCandidates.length === 0) return false;

  const firstStatus = selectedCandidates[0].application.status;
  return selectedCandidates.every((c) => c.application.status === firstStatus);
}

export function checkIfAnySelectedCandidatesAreRedacted(
  selectedCandidates: ListCandidate[],
): boolean {
  return selectedCandidates.some((c) => c.redacted);
}

export function checkIfSelectedCandidatesHaveSameJob(
  selectedCandidates: ListCandidate[],
): boolean {
  if (selectedCandidates.length === 0) return false;

  const firstJobId = selectedCandidates[0].application.job.id;
  return selectedCandidates.every((c) => c.application.job.id === firstJobId);
}

export function checkIfSelectedCandidatesAreInTheSameInterviewStage(
  selectedCandidates: ListCandidate[],
): boolean {
  if (selectedCandidates.length === 0) return false;

  const firstInterviewStageId =
    selectedCandidates[0].application.currentStage.interviewStageId;

  if (firstInterviewStageId == null) {
    return false;
  }

  return selectedCandidates.every(
    (c) =>
      c.application.currentStage.interviewStageId === firstInterviewStageId,
  );
}
